// extracted by mini-css-extract-plugin
export default {"loaderMask":"CustomDialog_loaderMask__VEz07","closeIcon":"CustomDialog_closeIcon__+dP2z"};